import { Pipe, PipeTransform } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

const formatSize = (bytes: number, sizes: string[]) => {
  const k = 1024;
  const dm = 3;

  if (bytes === 0) {
    return `0 ${sizes[0]}`;
  }

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const formattedSize = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

  return `${formattedSize} ${sizes[i]}`;
};

@Pipe({
  name: 'fileSizeFormat',
  standalone: true,
})
export class FileSizeFormatPipe implements PipeTransform {
  constructor(private config: PrimeNGConfig) {}
  transform(value: number): string {
    const sizes = this.config.translation.fileSizeTypes ?? [];
    return formatSize(value, sizes);
  }
}
